import { Button, Container, Dropdown } from '@gasbuddy/react-components';
import classnames from 'classnames/bind';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { getVehicleYearOptions } from '../../../lib/utils/vehicle';
import { VehicleOptionShape } from '../../prop-types/vehicle';
import styles from './VehicleRecallSearchBar.module.css';

const cx = classnames.bind(styles);

export default function VehicleRecallSearchBar({
  year,
  makeId,
  modelId,
  makeOptions,
  modelOptions,
  onFieldChange,
  onCheckRecalls,
}) {
  const { t } = useTranslation(['vehicle', 'miscellaneous']);
  return (
    <Container className={cx('searchBarContainer')}>
      <div className={cx('searchBar')}>
        <Dropdown
          name="year"
          id="year"
          label={t('selectYear')}
          placeholder={t('selectYearPlaceholder')}
          className={cx('dropDown')}
          options={getVehicleYearOptions()}
          value={year}
          onChange={onFieldChange}
        />
        <Dropdown
          name="makeId"
          id="makeId"
          label={t('selectMake')}
          placeholder={t('selectMakePlaceholder')}
          className={cx('dropDown', { controlDisabled: !year })}
          options={makeOptions}
          value={makeId}
          disabled={!year}
          onChange={onFieldChange}
          searchable
        />
        <Dropdown
          name="modelId"
          id="modelId"
          label={t('selectModel')}
          placeholder={t('selectModelPlaceholder')}
          className={cx('dropDown', { controlDisabled: !makeId })}
          options={modelOptions}
          value={modelId}
          disabled={!makeId}
          onChange={onFieldChange}
          searchable
        />
        <Button
          className={cx('searchBarButton')}
          primary
          disabled={!modelId}
          fluid
          onClick={onCheckRecalls}
        >
          {t('actions.checkNow', { ns: 'miscellaneous' })}
        </Button>
      </div>
    </Container>
  );
}

VehicleRecallSearchBar.propTypes = {
  year: PropTypes.number,
  makeId: PropTypes.number,
  modelId: PropTypes.number,
  makeOptions: PropTypes.arrayOf(VehicleOptionShape),
  modelOptions: PropTypes.arrayOf(VehicleOptionShape),
  onFieldChange: PropTypes.func.isRequired,
  onCheckRecalls: PropTypes.func.isRequired,
};

VehicleRecallSearchBar.defaultProps = {
  year: undefined,
  makeId: undefined,
  modelId: undefined,
  makeOptions: [],
  modelOptions: [],
};
